/**
 * In order to be able to remove the legacy of reduxActionWatch from the codebase we simply use
 * the code from the open source github repo and place it here under utils.
 * https://github.com/Codebrahma/redux-action-watch/blob/master/src/index.js
 *
 * Having the pkg itself installed was not working nicely with redux v4 so we just have to
 * include the code directly in our utils.
 */
import middleware from 'utils/reduxActionWatch/middleware';
import reducer from 'utils/reduxActionWatch/reducer';
import actionCreators from 'utils/reduxActionWatch/actionCreators';

export default {
    middleware,
    reducer,
    actionCreators
};
